/** API route map: URLS.Controller.GarnishmentStateRule */
export const GarnishmentStateRule = {
      Name: 'GarnishmentStateRule/',
      AddGarnishmentStateRule: 'add-garnishment-state-rule',
      SearchGarnishmentStateRule: 'search-garnishment-state-rule',
      GetGarnishmentStateRuleByCompany: 'get-garnishment-state-rule_by_company',
};
